



















































import Layout from '@/components/layouts/ModuleLayout/ModuleLayout.vue';
import Modal from '@/components/widgets/molecules/Modal/Modal.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TravelSection from './TravelSection/TravelSection.vue';
import LinkIcon from '@/components/icons/Link.vue';

@Component({
	components: {
		Layout,
		Modal,
		TravelSection,
		LinkIcon,
	},
})
export default class TravelPreviewModal extends Vue {
	@Prop({ required: true }) readonly visible!: boolean;
	@Prop({ required: true }) readonly id!: string;
	@Prop({ required: true }) readonly driverId!: string;
	@Prop({ required: true }) readonly travelId!: string;

	boarding = { odometro: '', data: '', imagens: [] as string[] };
	landing = { odometro: '', data: '', imagens: [] as string[] };
	travelBegin = { odometro: '', data: '', imagens: [] as string[] };

	get canLink() {
		return !!this.driverId && !!this.travelId;
	}

	linkToOrder() {
		if (!this.canLink) return;
		this.$emit('linkTravel', { idMotorista: this.driverId, id: this.travelId });
	}

	@Watch('visible')
	onVisibleChanged(newVal: boolean) {
		if (newVal) {
			this.clearValues();
			this.getTravelDetail();
		}
	}

	closeModal() {
		this.$emit('close');
	}

	async getTravelDetail() {
		try {
			const data = await this.$store.dispatch('TRANSIT_TRAVEL_DETACHED_DETAIL', this.id);

			this.boarding = data.embarque || { odometro: '', data: '', imagens: [] };
			this.landing = data.desembarque || { odometro: '', data: '', imagens: [] };
			this.travelBegin = data.inicioViagem || { odometro: '', data: '', imagens: [] };
		} catch (error) {
			console.error('❌ Erro ao obter detalhes da viagem:', error);
		}
	}

	clearValues() {
		this.boarding = { odometro: '', data: '', imagens: [] };
		this.landing = { odometro: '', data: '', imagens: [] };
		this.travelBegin = { odometro: '', data: '', imagens: [] };
	}
}
